export const SYS_ADMIN_AFFILIATE = "seiu_ada";
